import { Routes } from '@angular/router';

export const archiveRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./archived-orders-table/archived-orders-table.component').then((m) => m.ArchivedOrdersTableComponent),
  },
  {
    path: 'order/:id',
    loadComponent: () =>
      import('../packing/packing-order/packing-order.component').then((m) => m.PackingOrderComponent),
  },
];
